'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div>
      <h2>Something went wrong!</h2>
      <h2>{`please check :${error.message}`}</h2>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
        className='cursor-pointer rounded-[12px] border border-black p-[10px] dark:border-white dark:bg-black dark:text-white'
      >
        Try again
      </button>
    </div>
  );
}
